import React from 'react';
import type { ReadonlyDeep } from 'type-fest';

interface PageErrorProps {
	homepageButton?: boolean;
	reloadButton?: boolean;
}

function PageError(props: ReadonlyDeep<PageErrorProps>) {
	const { reloadButton = true, homepageButton = false } = props;

	const refreshPage = () => {
		location.reload();
	};

	return (
		<div className="InfoPage InfoPage--errorJS">
			<div className="InfoPage-cont">
				<h1 className="Page-title">Jejda, něco se pokazilo</h1>
				<p className="InfoPage-text">
					Můžete zkusit stránku obnovit nebo přejít na hlavní stránku, pokud se i tak nedaří,
					<a href="https://partner.seznam.cz/napoveda/#form2"> kontaktujte prosím naši podporu</a>.
				</p>
				{reloadButton && (
					<button className="InfoPage-buttonRefresh" onClick={refreshPage} type="button">
						Obnovit stránku
					</button>
				)}
				{homepageButton && (
					<a className="InfoPage-buttonSubmit" href="/">
						Přejít na hlavní stránku
					</a>
				)}
			</div>
		</div>
	);
}

export default PageError;
